/**
 * What `/home` resolves to: the first page this operator actually holds.
 *
 * It used to be `<Navigate to='/home' />` - a redirect to the route it was
 * already on. Anything that reached `/home` without a deeper segment looped
 * until the browser stopped it: a bookmark on `/home`, the "Go Back Home" link
 * on the 404 screen, or a login whose first `cmsPages` row was one of the three
 * GROUP HEADINGS, which carry an empty route and so produced no redirect target
 * at all.
 *
 * `landing` comes from `services/pageAccess.js`, which walks the whole menu
 * tree in order and skips the headings. When there is nothing to land on it
 * returns the no-permission screen, so a user with no pages gets an explanation
 * instead of an empty shell.
 */

import React from 'react';
import { Navigate } from 'react-router-dom';

import Loader from '../components/Molecules/Loader/Loader';
import { usePageAccess } from '../Context/PageAccessContext';

const LandingRedirect = () => {
  const { isLoading, landing } = usePageAccess();

  // Redirecting before the pages are known would send everyone to the
  // no-permission screen for a frame, and `replace` would bury the real
  // destination in the history.
  if (isLoading) return <Loader />;

  return <Navigate to={landing} replace />;
};

export default LandingRedirect;
